module.exports = __webpack_public_path__ + "static/media/mine.773c922a.jpeg";